import { useState, createContext, Dispatch, SetStateAction } from 'react'

interface TeamsContextType {
  teamApps: any
  setTeamApps: Dispatch<SetStateAction<any>>
  teamDataboxes: any
  setTeamDataboxes: Dispatch<SetStateAction<any>>
}

export const TeamsContext = createContext<TeamsContextType>({} as TeamsContextType)

interface TeamsProviderProps {
  children: React.ReactNode
}

const TeamsProvider: React.FC<TeamsProviderProps> = ({ children }) => {
  const [teamApps, setTeamApps] = useState<any>(null)
  const [teamDataboxes, setTeamDataboxes] = useState<any>(null)

  return (
    <TeamsContext
      value={{
        teamApps,
        setTeamApps,
        teamDataboxes,
        setTeamDataboxes
      }}>
      {children}
    </TeamsContext>
  )
}

export { TeamsProvider }
